import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { FormalizeCommunicationArgs } from '@ztechapps/common.contract'

export const FORMALIZE_COMMUNICATION_MUTATION = gql`
  mutation formalizeCommunication($input: FormalizeCommunicationArgs!) {
    formalizeCommunication(input: $input)
  }
`

const defaultQuery = FORMALIZE_COMMUNICATION_MUTATION

export const useFormalizeCommunication = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? defaultQuery

  return useMutation<{ formalizeCommunication: string }, FormalizeCommunicationArgs>({ query, ...props })
}
